export default __webpack_public_path__ + "static/media/me.540bee70.svg";